import { configure, makeAutoObservable } from "mobx";
import io from "socket.io-client";
// import { TimelineMax, TweenLite, Linear } from "gsap";

configure({
  enforceActions: "observed"
})

class EventStore {
  isLoading = false;
  event = {};
  eventID = 0;
  overallraised = 0;
  overallgoal = 0;
  overallpercent = 0;
  overallgoal = 0;
  overallgoalVal = 0;
  overallprogress = 0;
  socket = false;
  error = false;

  constructor () {
    makeAutoObservable(this)
  }

  eventSocketDisconnect() {
    this.socket.disconnect();
  }

  eventSocketConnect(eventID) {
    this.setIsLoading(true);
    this.eventID = eventID;
    this.socket = io(process.env.REACT_APP_EVENT_SERVICE_URI, {
      query: `id=${eventID}`,
      withCredentials: false,
    });

    console.log(process.env.REACT_APP_EVENT_SERVICE_URI)

    this.socket.on("error", error => {
      console.log("error", error);
      this.setError(error);
    });

    this.socket.on("connect_error", error => {
      console.log("connect_error", error);
      this.setError(error);
    });

    this.socket.on("events", data => {
      const event = data;
      this.setEvent(event);
      this.setError(false);

      this.socket.on("overalltotals", data => {
        const event = data;
        this.setError(false);
        this.setEvent(event);
        this.setTotals(event)
      });

      this.socket.emit("getData", this.eventID);
      this.setIsLoading(false);
    });
  }

  setError = error => {
    this.error = error;
  }

  setEvent = event => {
    this.event = event;
  }

  setIsLoading = boolean => {
    this.isLoading = boolean;
  }

  setTotals = event => {
    const formatNumber = num => {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };

    this.overallraised = event.total_amount_raised ? event.total_amount_raised.value : 0;
    // this.overallgoal = formatNumber(this.overalltotal.fundraiserGoalAmount);
    if (event.goal && event.goal.value > 0) { 
      this.overallgoal = event.goal.value;
      this.overallgoalVal = formatNumber(event.goal.value);

      this.overallpercent = Math.round(
        100 * (parseFloat(this.overallraised) / parseFloat(this.overallgoal))
      );

      this.overallprogress = this.overallpercent > 100 ? 100 : this.overallpercent;
        // console.log("OVERALLTOTAL", data);
    }
  }
}

export default new EventStore();
